module.exports = __webpack_public_path__ + "static/img/5.9fe1e31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/hsyl/hjzz/5.png
// module id = eJtV
// module chunks = 1